import { notification } from 'antd';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { LatestOrders } from './latest-orders';
import { RevenueValues } from './revenue-values';

export function EventsRoute(): JSX.Element {
	const [showError, setShowError] = useState<boolean>(false);

	useEffect(() => {
		if (showError === true) {
			notification.error({ message: 'Netværks fejl', onClose: () => setShowError(false) });
		}
	}, [showError]);

	return (
		<Container className="dashboard-container">
			<RevenueValues />
			<LatestOrders />
		</Container>
	);
}

const Container = styled.main`
	background-color: #1a202c;
	display: flex;
	flex-direction: column;
`;
